import { IMenuDataInfo } from "./types";

type ErrorCallback = () => void;

export const handleApiError = (
    response: IMenuDataInfo,
    setErrorState: (value: boolean) => void,
    ...additionalCallbacks: ErrorCallback[]
): boolean => {
    setErrorState(true);
    const { failure } = response;
    if (failure) {
        // Execute all additional callback functions
        additionalCallbacks.forEach((callback) => callback());
        // You can add more specific error handling based on errorCode if needed
        switch (failure.errorCode) {
            case 520:
                // Handle specific error
                break;
            // Add more cases as needed
            default:
                // Default error handling
                break;
        }

        return true; // Indicating that an error was handled
    }
    return false; // Indicating that no error was found
};
